var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChildMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.46 11.064v.604c-2.068 0-1.931 3.556.36 3.556h.006a7.214 7.214 0 006.884 4.98 7.208 7.208 0 006.879-4.98h.006c2.29 0 2.43-3.556.362-3.556v-2.63",
    stroke: "#0B966B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35 10.96a.896.896 0 00-.906.886c0 .491.405.89.906.89.5 0 .906-.399.906-.89a.897.897 0 00-.906-.887M12.06 10.96a.896.896 0 00-.903.886c0 .491.406.89.902.89.503 0 .91-.399.91-.89a.898.898 0 00-.91-.887",
    fill: "#0B966B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.897 16.002a3.324 3.324 0 003.625 0M5.733 7.383c3.177 3.024 8.661 2.526 11.964 1.431C17.688 4.498 14.12 1 9.719 1 5.318 1 1.746 4.503 1.746 8.825v2.471s3.987-.978 3.987-3.913",
    stroke: "#0B966B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconChildMaintenance;